import { CallStatus, TabType } from '@/const/business';
const defaultQuery = {
  // 查询患者列表参数
  departmentId: '', // 科室id
  doctorId: '', // 医生id、
  favorite: 0, // 是否已关注
  currentPage: 0,
  pageSize: 20,
  key: '', // 按患者姓名查询
  hospitalPatientId: '', // 院内ID
  groupIdList: [], // 分组筛选
  patientRegisterNo: '', // 院内登记号(在中肿叫病历号)
  doctorGroupId: '',
  opType: 1, // 标签筛选逻辑，1：并且，2：或者
  systemTags: [], // 系统标签
  customTags: [], // 自定义标签
  managerUserIds: [], // 管理师筛选
  registerTime: {}, // 注册时间 { start?, end?, sort? }
  lastCommunicationTime: {}, // 最近沟通时间 { start?, end?, sort? }
  lastFollowUpTime: {}, // 最近随访时间 { start?, end?, sort? }
};
const state = {
  remindSum: 0, // 未读消息数
  showHeader: true,
  patientList: [],
  visitPatientList: [],
  visitCount: 0,
  preInquiryPatientList: [],
  preInquiryPatientCount: 0,
  importSelectList: [],
  visitSelectList: [],
  selectList: [],
  selectPatientId: '', // 选中患者id
  count: 0, // 患者列表总条数
  issueFormPatientList: [],
  issueFormCount: 0,
  loading: false,
  reportLoading: true, // 检验/检查报告的loading
  checkReportRightLoading: true, // 检验/检查报告的右侧的loading
  patientName: '', // 搜索框患者姓名
  defaultQuery,
  query: {
    ...defaultQuery,
  },
  currentRouter: {}, // 当前路由
  currentTabIndex: TabType.checkReport, // 当前tab
  provinceList: [],
  cityList: [],
  districtList: [],
  streetList: [],
  currentOutCallPatient: {
    patientPhone: '',
    patientName: '',
  },
  outCallComponentShow: false,
  outCallIng: false,
  outCallRouter: {},
  callStatus: CallStatus.over, // 通话状态
  qdTalkTime: 0, // 企点通话时间
  tccSessionId: '', // 电话会话id
  tccTimer: null, // 电话会话定时器
  remark: '', // 备注内容
  callId: '', // 外呼电话id
  callRecordDetail: [], // 语音转文字内容
  qdIsMute: false, // 是否静音
  intervalTime: 0, // 间隔时间
  isNeedFormCheck: false, // 计划是否需要开启检验
  childPlanId: 0, // 子计划id
  isNeedSaveTip: false, // 是否需要保存提示
  currentPlanIndex: 0, // 当前子计划
  groupCurrentPage: 0, // 分组列表页当前页数
  groupPageSize: 10, // 分组列表页每页显示条目个数
  messageCurrentPage: 0, // 消息列表页当前页数
  messagePageSize: 10, // 消息列表页每页显示条目个数
  patientCurrentPage: 0, // 患者列表页当前页数
  patientPageSize: 20, // 患者列表页最大条目数
  favoriteCurrentPage: 0, // 收藏页当前页数
  favoritePageSize: 20, // 收藏页最大条目数
  isNeedFormCheck: false, // 随访计划是否需要开启检验
  matchQuery: {
    // 湖南省肿瘤医院院内部署场景参数
    currentPage: 1,
    pageSize: 20,
    patientId: '',
    updateTime: '',
    diseaseName: '',
  },
  inHospitalSelectList: [],
  inHospitalFocusSelectList: [],
  inHospitalGroupCurrentPage: 0, // 院内分组列表页当前页数
  inHospitalGroupPageSize: 10, // 院内分组列表页每页显示条目个数
  inHospitalMessageCurrentPage: 0, //  院内消息列表页当前页数
  inHospitalMessagePageSize: 10, //  院内消息列表页每页显示条目个数
  preInquiryVisitId: '', // 预问诊vistId
  isOpenFillDialog: false, // 时间轴前往计划页面是否弹出填写弹窗
  planFillData: {}, //  计划弹窗填写数据
  organType: 0, // 机构类型
  tagFilterSelectedList: [], // 患者列表标签筛选已选择列表
  isShowTagInfo: false, // 列配置中是否勾选了需要额外返回的标签字段（身高/体重/BMI/疾病信息/健康指标/生活方式/行为属性/自定义标签）
  tagInfoLoading: false, // 标签字段独立加载状态
  // 家医模块相关状态
  familyDoctorSelectList: [], // 家医模块选中的居民列表
};

export default state;
